import useEmitter from '@/composables/useEmitter'
import { useTemplateFilter } from '@/composables/useTemplateFilter.js'
import { v4 as uuidv4 } from 'uuid'
import { notify } from 'notiwind'

export function useNotification () {
  const defaultOptions = {
    type: 'notice',
    sound: false,
    timeout: 5000,
    title: null,
    close: true,
    text: '',
    icon: null,
    route: null,
    extraPayload: null,
    variant: 'success',
    button: null,
    notify: true
  }

  // const emitter = useEmitter()

  const setOptions = (options) => {
    return Object.assign({}, defaultOptions, options)
  }

  const sendBookingToast = (data) => {
    const { accommodation_id: id, booking_code: bookingCode, arrival_on: arrivalOn, price_total: priceTotal, departure_on: departureOn } = data

    const { formatFloat } = useTemplateFilter()
    const message = `Zeitraum: ${arrivalOn} - ${departureOn} (${formatFloat(priceTotal)} EUR).`

    createNotification({
      type: 'toast',
      content: message,
      title: 'Neue Onlinebuchung',
      sound: 'notification',
      actionLabel: 'Zur Buchung',
      actionRoute: {
        name: 'obu-bookings-details',
        params: {
          id,
          bookingCode
        }
      },
      timeout: 10000
    })
  }

  const sendDocumentToast = (data) => {
    const { id, title, reference } = data

    const message = `${title} ${reference} wurde erstellt.`

    sendNotice('Neues Dokument wurde erstellt', {
      text: message,
      buttonTitle: 'Dokument öffnen',
      buttonRoute: { name: 'obu-documents-details', params: { did: id } },
      imgSrc: 'https://japi.ovh.next.tourismusnetz.com/media/17803/400',
      statusIcon: 'tabler-file'
    }, 'message', 10000)
  }

  const hideNotification = (id) => {
    /*
    const emitter = useEmitter()
    console.log(emitter)
    // const { emit } = useEventBus('global.notifications.hide')
    (id)
    */
  }

  const showAxiosError = (error, title = 'Server-Fehler') => {
    sendNotice(title, {
      text: JSON.stringify(error.response)
    }, 'axios', 60000)
  }

  const sendSpinner = (content) => {
    const id = uuidv4()
    createNotification({
      id,
      type: 'spinner',
      content,
      permanent: true
    })
    return id
  }

  const createNotification = (options) => {
    const settings = setOptions(options)
    // emitter.emit('global.notifications.show', settings)
  }

  const sendNotice = (title = 'Benachrichtigung', content = {}, type = 'notice', timeout = 3000, group = 'default') => {
    const result = notify({
      group,
      title,
      type,
      text: content
    }, timeout)
    return result
  }

  const sendNoticeByPayload = (payload = {}) => {
    payload = setOptions(payload)
    const result = sendNotice(payload.title, payload.content, payload.type, payload.timeout, payload.group)
    return result
  }

  return {
    showAxiosError, sendNotice, sendBookingToast, sendDocumentToast, sendSpinner, hideNotification, sendNoticeByPayload
  }
}
